export default [
    {
        path: '/present',
        props: true,
        component: () => import('@/views/Present'),
    },
];